import React from 'react';
import { StarIcon, TimerIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { BuyButton } from './ui/BuyButton';
interface HeroProps {
  countdown: {
    hours: string;
    minutes: string;
    seconds: string;
  };
}
export function Hero({
  countdown
}: HeroProps) {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-53" data-mp="4mrul1r1q1lr">
      {/* Top Banners */}
      <div className="bg-sage-800 py-2.5 text-center" data-id="element-54" data-mp="129qwps0ic1r1">
        <p className="px-4 text-[11px] font-bold uppercase tracking-overline text-gold-200" data-id="element-55" data-mp="1274orr9pfk8a">
          PRODUCTO 100% DIGITAL - ACCESO INMEDIATO
        </p>
      </div>
      <div className="bg-terracotta-500 py-2 text-center" data-id="element-56" data-mp="s9q7jpfyirex">
        <p className="flex items-center justify-center gap-2 px-4 text-[12px] font-semibold uppercase tracking-wider text-cream" data-id="element-57" data-mp="ncq1hej3xont">
          <TimerIcon className="h-4 w-4" data-id="element-58" data-mp="3d2bkprwf73wl" />
          Oferta por tiempo limitado:{' '}
          <span className="font-bold" data-id="element-59" data-mp="381e2xgfbobvm">
            {countdown.minutes}:{countdown.seconds} MINUTOS
          </span>
        </p>
      </div>

      <div className="mx-auto max-w-4xl px-5 pb-16 pt-10 text-center sm:px-8 lg:pb-24 lg:pt-16" data-id="element-60" data-mp="3j6fy7px5bddu">
        <p className="inline-flex items-center justify-center gap-2 rounded-full border border-gold-200/60 bg-bone px-4 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.2em] text-terracotta-600" data-id="element-61" data-mp="3o6u5h5qxajat">
          PRENSAR · CONSERVAR · CREAR · VENDER
        </p>

        <h1 className="mt-8 font-serif text-[2.7rem] leading-[1.05] text-sage-900 sm:text-[4rem] lg:text-[4.5rem]" style={{
        fontWeight: "600"
      }} data-id="element-62" data-mp="30gzwiz9q5evu">
          Convertí flores reales en piezas decorativas que podés{' '}
          <span className="italic text-terracotta-500" data-id="element-63" data-mp="2qloh0eqhs3n1">crear, regalar</span> y vender.
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] leading-relaxed text-ink-soft sm:text-[18px]" data-id="element-64" data-mp="2vj7u3bbgeade">
          Aprendé paso a paso cómo prensar, conservar y transformar flores en cuadros,
          tarjetas y creaciones botánicas delicadas, sin arruinarlas ni perder su
          belleza natural.
        </p>

        <div className="mx-auto mt-8 flex w-fit items-center justify-center gap-3 rounded-full border border-gold-200/50 bg-cream px-5 py-2.5 shadow-sm" data-id="element-65" data-mp="s44ifoom7nif">
          <div className="flex -space-x-2" data-id="element-66" data-mp="id9vei3jojvx">
            <img src={testimonials[0].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-67" data-mp="ia5fingpvzpf" />
            <img src={testimonials[1].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-68" data-mp="1b0nk5sx3a94y" />
            <img src={testimonials[2].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-69" data-mp="161jc55lwihg7" />
          </div>
          <div className="flex items-center gap-0.5" data-id="element-70" data-mp="110wpnr8j3u4v">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" data-id="element-71" data-mp="x3h1rzga2cg9" data-mpi={i} />)}
          </div>
          <p className="text-[12px] font-medium text-sage-800" data-id="element-72" data-mp="3lqm3q21erbwi">
            4.9 / 5 · +2.400 mujeres ya prensaron su primera flor
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-[320px] sm:max-w-[380px]" data-id="element-73" data-mp="1xam54pmyxoye">
          <video src="https://cdn.magicpatterns.com/uploads/2wRpXzWTbvjt7TCJ8MhCuA/IMG_4208.MOV" autoPlay loop muted playsInline className="aspect-[9/16] w-full rounded-[2rem] object-cover shadow-[0_30px_60px_-15px_rgba(56,52,44,0.3)]" data-id="element-74" data-mp="21aeg18zu476x" />
        </div>

        <div className="mt-12 flex flex-col items-center gap-3" data-id="element-75" data-mp="2b2smug5rs3zy">
          <BuyButton size="xl" label="Quiero empezar con Deco Flores" href="#oferta" data-id="element-76" data-mp="2fyr8hvzpr7wo" />
          <p className="text-[12.5px] font-medium text-ink-light" data-id="element-77" data-mp="2ky42r1swzh9a">
            Producto digital · acceso inmediato
          </p>
        </div>
      </div>
    </header>;
}